module.exports = __webpack_public_path__ + "static/media/ReturnTracking1.1a88ed66.png";